import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is defined in your project
import { useNavigate } from 'react-router-dom';

const PriceLists = () => {
    const [priceLists, setPriceLists] = useState([]);
    const [filteredPriceLists, setFilteredPriceLists] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        fetch(`${BASE_URL}pricelists`)
            .then(response => response.json())
            .then(data => {
                if (data.status === "success") {
                    setPriceLists(data.data);
                    setFilteredPriceLists(data.data);
                }
            })
            .catch(error => console.error('Error fetching price lists:', error));
    }, []);

    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
        const filtered = priceLists.filter(list =>
            list.description.toLowerCase().includes(term.toLowerCase()) ||
            list.item_name.toLowerCase().includes(term.toLowerCase())
        );
        setFilteredPriceLists(filtered);
    };

    const handleEdit = (id) => {
        navigate(`/EditPriceList/${id}`);
    };

    const handleAdd = () => {
        navigate('/AddPriceList');
    };

    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this price list?")) {
            fetch(`${BASE_URL}pricelists/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 'success') {
                        setPriceLists(priceLists.filter(list => list.id !== id));
                        setFilteredPriceLists(filteredPriceLists.filter(list => list.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting price list:', error));
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <h3>Price Lists</h3>
            </div>

            <section className="section">
                <div className="card">
                    <div className="card-header d-flex justify-content-between">
                        
                        <button className="btn btn-primary" onClick={handleAdd}>Add Price List</button>
                    </div>
                    <div className="card-body">
                        <div className="table-responsive">
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>Description</th>
                                        <th>Price Category</th>
                                        <th>Effective From</th>
                                        <th>Item Code</th>
                                        <th>Barcode</th>
                                        <th>Item Name</th>
                                        <th>Item Type</th>
                                        <th>Rate</th>
                                        <th>Dealer Rate</th>
                                        <th>Wholesale Rate</th>
                                        <th>MRP</th>
                                        <th>Discount</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredPriceLists.map(list => (
                                        <tr key={list.id}>
                                            <td>{list.id}</td>
                                            <td>{list.description}</td>
                                            <td>{list.price_category}</td>
                                            <td>{new Date(list.effective_from).toLocaleDateString()}</td>
                                            <td>{list.item_code}</td>
                                            <td>{list.barcode}</td>
                                            <td>{list.item_name}</td>
                                            <td>{list.item_type}</td>
                                            <td>{list.rate}</td>
                                            <td>{list.dealer_rate}</td>
                                            <td>{list.wholesale_rate}</td>
                                            <td>{list.mrp}</td>
                                            <td>{list.discount}</td>
                                            <td>
                                                <button
                                                    className="btn btn-warning btn-sm me-2"
                                                    onClick={() => handleEdit(list.id)}
                                                >
                                                    Edit
                                                </button>
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(list.id)}
                                                >
                                                    Delete
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                    {filteredPriceLists.length === 0 && (
                                        <tr>
                                            <td colSpan="14" className="text-center">No price lists found</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default PriceLists;
